import { defineComponent as _defineComponent } from 'vue'
import BaseButton from "@/components/buttons/BaseButton.vue";
import { ref, useAttrs } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'IconButton',
  setup(__props, { expose: __expose }) {
  __expose();

const attrs = useAttrs();
const iconName = ref(Object.keys(attrs).find(key => key.startsWith("mdi-")));

const __returned__ = { attrs, iconName, BaseButton }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})